import React, { useState,useEffect } from "react";
import StadoPayrollFooter from "./StadoPayrollFooter";

export default function PrivacyPolicy() {
  const [isAgreed, setIsAgreed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.title = "PrivacyPolicy – Stado Payroll";
  
    const link = document.querySelector("link[rel~='icon']");
    if (link) link.href = "/payrollfavicons.png";
  }, []);


  const handleAgreeClick = () => {
    setIsLoading(true);
    
    // Simulating a response delay (e.g., saving to local storage or API)
    setTimeout(() => {
      setIsLoading(false);
      setIsAgreed(true);
      
      // Optional: Logic to redirect or close modal
      // window.location.href = "/dashboard";
    }, 1200);
  };

  return (
    <>
      <section className="relative bg-[#050505] text-gray-200 py-20 px-4 overflow-hidden font-sans">
        
        {/* Soft Brand Glow Effects */}
        <div className="pointer-events-none absolute -top-40 -left-40 w-[420px] h-[420px] rounded-full bg-[#f68c51]/20 blur-[160px]" />
        <div className="pointer-events-none absolute top-1/2 -right-40 w-[420px] h-[420px] rounded-full bg-[#fd2c55]/20 blur-[160px]" />

        <div className="relative max-w-5xl mx-auto leading-relaxed text-sm md:text-base space-y-8">
          
          {/* TITLE SECTION */}
          <div className="text-center mb-14">
            <h1 className="text-3xl md:text-4xl mt-10 font-bold text-white tracking-wide">
              Privacy Policy
            </h1>
            <div className="mt-3 h-[2px] w-24 mx-auto rounded-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
            <p className="mt-4 italic text-gray-400">Last Updated: 06.12.2025</p>
          </div>

          <p>
            <strong>Stado Payroll</strong> (“Company”, “we”, “our”, “us”) operates the website 
            <span className="text-[#f68c51]"> stadoworld.com</span> and provides HRMS, attendance, payroll, and workforce-management solutions. 
            This Privacy Policy explains how we collect, use, store, share, and protect your information when you use our Website, Dashboard, Mobile App, or any related service (“Services”).
          </p>

          <p className="font-semibold text-white uppercase border-l-4 border-[#f68c51] pl-4 bg-white/5 rounded-md py-3">
            BY ACCESSING OR USING OUR SERVICES, YOU AGREE TO THIS PRIVACY POLICY. IF YOU DO NOT AGREE, PLEASE REFRAIN FROM USING OUR PLATFORM.
          </p>

          {/* SECTION 1 */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            1. Information Collection
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>We collect information through three primary channels:</p>
          <ul className="list-disc pl-6 space-y-2 text-gray-300">
            <li><strong>Directly Provided:</strong> Full name, email address, phone number, organization name, payment details, and support queries.</li>
            <li><strong>Automatically Collected:</strong> IP address, device information, browser type, session logs, and usage patterns.</li>
            <li><strong>Employer-Provided:</strong> Employee IDs, attendance & location data, salary structures, and bank/UPI information.</li>
          </ul>

          {/* SECTION 2 */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            2. Location Data (Foreground & Background)
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <div className="bg-white/5 p-6 rounded-lg border border-gray-800">
            <p className="mb-4">Our application may collect location data in foreground and background modes (even when the app is closed if continuous tracking is enabled by your employer) for core HRMS features:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-300 text-sm">
              <li>Accurate attendance and geo-fencing verification.</li>
              <li>Travel and field-work tracking for permitted employees.</li>
              <li>Preventing fraudulent attendance marking and ensuring employee safety.</li>
            </ul>
            <p className="mt-4 text-xs text-gray-400 italic">We do not use location data for advertising or profiling. You may disable access in device settings at any time.</p>
          </div>

          {/* SECTION 3 */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            3. How We Use Your Information
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>We utilize your data to provide and optimize our payroll automation services, enable secure role-based authentication, process subscription billing, and maintain overall platform security and fraud prevention.</p>

          {/* SECTION 4 */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            4. How We Share Your Information
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>We share data only with trusted partners necessary for operations (e.g., cloud hosting, Razorpay for payments, SMS/Email services) or as required by law. <strong>We never sell your location or personal data to external advertisers.</strong></p>

          {/* SECTION 5 */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            5. Data Security & Storage
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>
            We implement industry-standard security including <strong>HTTPS/TLS encryption</strong>, secure password hashing, and multi-layer server protection. We retain information as long as your account is active or as legally required for auditing.
          </p>

          {/* SECTION 6 */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            6. Your Rights
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>You have the right to request access to your data, correction of errors, or deletion (where legally permitted). You may also request an export of your account info or opt-out of non-essential communications by contacting us.</p>

          {/* SECTION 7 */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            7. Cookies & Third-Party Links
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>Stado Payroll uses cookies to maintain login sessions and improve dashboard experience. We are not responsible for the privacy practices of external websites linked within our platform.</p>

          {/* SECTION 8 */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            8. Children's Privacy
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>Stado Payroll is a professional B2B platform and is not intended for individuals under 18 years. We do not knowingly collect data from minors.</p>

          {/* SECTION 9 */}
          <h2 className="text-xl font-semibold text-white pt-8 relative inline-block">
            9. Changes & Contact
            <span className="absolute left-0 -bottom-1 h-[2px] w-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
          </h2>
          <p>We may update this policy periodically. For any concerns or privacy requests, please contact us at:</p>

          <div className="bg-white/5 p-4 rounded-md border border-gray-800 space-y-2">
            <p><strong>Stado Payroll</strong></p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:support@stadoworld.com" className="text-[#f68c51] hover:underline transition-colors">
                support@stadoworld.com
              </a>
            </p>
            <p>
              <strong>Website:</strong>{" "}
              <a href="https://payroll.stadoworld.com" className="text-[#fd2c55] hover:underline transition-colors">
                https://payroll.stadoworld.com
              </a>
            </p>
          </div>

          {/* AGREE BUTTON SECTION */}
          <div className="flex flex-col items-center justify-center pt-14 gap-4">
            <button 
              onClick={handleAgreeClick}
              disabled={isLoading || isAgreed}
              className={`
                relative overflow-hidden
                px-10 py-3
                rounded-full
                font-semibold
                text-white
                shadow-lg
                transition-all duration-300
                ${isAgreed 
                  ? "bg-green-600 shadow-[0_0_25px_rgba(22,163,74,0.4)]" 
                  : "bg-gradient-to-r from-[#f68c51] to-[#fd2c55] hover:scale-105 hover:shadow-[0_0_30px_rgba(253,44,85,0.45)] active:scale-95"
                }
                ${isLoading ? "opacity-70 cursor-wait" : ""}
                ${isAgreed ? "cursor-default" : "cursor-pointer"}
              `}
            >
              {isLoading ? (
                <span className="flex items-center gap-2">
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Processing...
                </span>
              ) : isAgreed ? "YOU HAVE AGREED" : "I AGREE"}
            </button>
            
            {isAgreed && (
              <p className="text-green-400 text-sm animate-fade-in font-medium">
                Successfully accepted! Your preference has been recorded.
              </p>
            )}
          </div>

          

        </div>
      </section>
      <StadoPayrollFooter/>
    </>
  );
}